// Configuración de la instancia (entidad financiera). Se define en .env y se lee al compilar:
//   REACT_APP_BRAND_NAME        nombre visible (footers, textos, title de index.html)
//   REACT_APP_REGISTER_ENABLED  'false' oculta "Regístrese ahora" en el login y deshabilita /register

export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME?.trim() || 'SwiftMart';

export const REGISTER_ENABLED = process.env.REACT_APP_REGISTER_ENABLED?.trim().toLowerCase() !== 'false';

//   REACT_APP_COUNTRY_ID / REACT_APP_BANK_ID  país (1 Costa Rica, 2 Panamá) y banco de la instancia (Swiftmart: Swiftpay, ID 1).
//                                             Sin banco: los comercios que se registran quedan sin banco y sin pago con tarjeta.
const toId = (value?: string) => {
    const id = Number(value?.trim());
    return Number.isInteger(id) && id > 0 ? id : null;
};

export const INSTANCE_COUNTRY_ID = toId(process.env.REACT_APP_COUNTRY_ID) ?? 1;
export const INSTANCE_BANK_ID = toId(process.env.REACT_APP_BANK_ID);
export const CARD_PAYMENTS_ENABLED = INSTANCE_BANK_ID !== null;

// Banco Swiftpay (SWIFT_BANCO.ID = 1): sus comercios tienen terminales por moneda
export const SWIFTPAY_BANK_ID = 1;

//   REACT_APP_SELF_ONBOARDING_ENABLED  'false' oculta "Cree su comercio" en el login y deshabilita /signup (registro autogestionado)
export const SELF_ONBOARDING_ENABLED = process.env.REACT_APP_SELF_ONBOARDING_ENABLED?.trim().toLowerCase() !== 'false';

//   REACT_APP_INSTANCE  carpeta de public/ (favicon, manifest), logos de la app y clase del body con la paleta de la instancia
export const INSTANCE = process.env.REACT_APP_INSTANCE?.trim().toLowerCase() || 'swiftmart';

//   REACT_APP_SITE_URL  dominio público del frontend (retorno del 3DS, enlaces absolutos). Sin valor: el dominio desde el que se abre la app
export const SITE_URL = (process.env.REACT_APP_SITE_URL?.trim() || window.location.origin).replace(/\/$/, '');
